var React = require('react');

function NaviTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m280-400 200-200 200 200H280Z"}));
}

NaviTop.defaultProps = {"height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#e3e3e3"};

module.exports = NaviTop;

NaviTop.default = NaviTop;
